import { Box, ButtonBase, Typography } from '@mui/material';
import { CheckCircleIcon, colors, palette, SprayIcon, UsersOutlineIcon } from '@silbo/ui';
import { Link, useLocation } from '@tanstack/react-router';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProfileDialog from '../../bed-management/components/ProfileDialog';

type TabProps = {
  icon: ReactNode;
  label: string;
  isActive: boolean;
};

const Tab = ({ icon, label, isActive }: TabProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '3px',
      width: '100%',
      color: isActive ? palette.primary.main : colors.grey[40],
      '& .MuiSvgIcon-root': { fontSize: 28 },
    }}
  >
    {icon}
    <Typography sx={{ fontSize: 11, fontWeight: isActive ? 600 : 500, color: 'inherit' }}>{label}</Typography>
  </Box>
);

const tabLinkStyle = { display: 'flex', textDecoration: 'none' } as const;

const CleaningBottomBar = () => {
  const { t } = useTranslation('environmental-cleaning');
  const { pathname } = useLocation();
  const [isProfileOpen, setProfileOpen] = useState(false);

  return (
    <Box
      component="footer"
      sx={{
        flex: 'none',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        paddingTop: 2,
        paddingBottom: 'calc(env(safe-area-inset-bottom) + 8px)',
        bgcolor: palette.background.default,
        borderTop: `1px solid ${colors.grey[10]}`,
      }}
    >
      <Link to="/environmental-cleaning/missions" style={tabLinkStyle}>
        <Tab
          icon={<SprayIcon />}
          label={t('navigation.missions')}
          isActive={pathname.includes('/environmental-cleaning/missions')}
        />
      </Link>
      <Link to="/environmental-cleaning/done" style={tabLinkStyle}>
        <Tab
          icon={<CheckCircleIcon />}
          label={t('navigation.done')}
          isActive={pathname.includes('/environmental-cleaning/done')}
        />
      </Link>
      <ButtonBase disableRipple onClick={() => setProfileOpen(true)}>
        <Tab icon={<UsersOutlineIcon />} label={t('navigation.account')} isActive={isProfileOpen} />
      </ButtonBase>
      <ProfileDialog open={isProfileOpen} onClose={() => setProfileOpen(false)} />
    </Box>
  );
};

export default CleaningBottomBar;
